import { Guardian } from '@xaamin/guardian';

Guardian.define('factura.crear', (user) => {
  return user.can('factura.crear');
});

Guardian.define('factura.crear.ingreso', (user) => {
  return user.can('factura.crear.ingreso');
});

Guardian.define('factura.crear.egreso', (user) => {
  return user.can('factura.crear.egreso');
});

Guardian.define('factura.crear.nomina', (user) => {
  return user.can('factura.crear.nomina');
});

Guardian.define('factura.crear.pago', (user) => {
  return user.can('factura.crear.pago');
});

Guardian.define('factura.crear.traslado', (user) => {
  return user.can('factura.crear.traslado');
});

Guardian.define('factura.listar', (user) => {
  return user.can('factura.listar');
});

Guardian.define('factura.info', (user) => {
  return user.can('factura.info');
});

Guardian.define('factura.validar', (user) => {
  return user.can('factura.validar');
});

Guardian.define('factura.cancelar', (user) => {
  return user.can('factura.cancelar');
});

Guardian.define('factura.clonar.nota.credito', (user) => {
  return user.can('factura.clonar.nota.credito');
});

Guardian.define('factura.clonar.nota.debito', (user) => {
  return user.can('factura.clonar.nota.debito');
});

Guardian.define('factura.clonar.documento', (user) => {
  return user.can('factura.clonar.documento');
});

Guardian.define('factura.descarga.masiva.pdf', (user) => {
  return user.can('factura.descarga.masiva.pdf');
});

Guardian.define('factura.descarga.masiva.xml', (user) => {
  return user.can('factura.descarga.masiva.xml');
});

Guardian.define('factura.descarga.masiva.csv', (user) => {
  return user.can('factura.descarga.masiva.csv');
});

Guardian.define('factura.listar.todos', (user) => {
  return user.can('factura.listar.todos');
});

Guardian.define('factura.listar.ingreso', (user) => {
  return user.can('factura.listar.ingreso');
});

Guardian.define('factura.listar.egreso', (user) => {
  return user.can('factura.listar.egreso');
});

Guardian.define('factura.listar.pago', (user) => {
  return user.can('factura.listar.pago');
});

Guardian.define('factura.listar.nomina', (user) => {
  return user.can('factura.listar.nomina');
});

Guardian.define('factura.listar.traslado', (user) => {
  return user.can('factura.listar.traslado');
});

Guardian.define('factura.listar.vigentes', (user) => {
  return user.can('factura.listar.vigentes');
});

Guardian.define('factura.listar.cancelados', (user) => {
  return user.can('factura.listar.cancelados');
});

Guardian.define('factura.listar.manual', (user) => {
  return user.can('factura.listar.manual');
});

Guardian.define('factura.listar.masiva', (user) => {
  return user.can('factura.listar.masiva');
});

Guardian.define('factura.listar.autofacturacion', (user) => {
  return user.can('factura.listar.autofacturacion');
});

Guardian.define('factura.listar.global', (user) => {
  return user.can('factura.listar.global');
});

// Se combinaron los permisos de descargas de facturas y autofacturacion

Guardian.define('factura.descargar.zip', (user) => {
  return user.can([
    'factura.descargar.zip',
    'autofacturacion.descargar.zip'
  ]);
});

Guardian.define('factura.descargar.pdf', (user) => {
  return user.can([
    'factura.descargar.pdf',
    'autofacturacion.descargar.pdf'
  ]);
});

Guardian.define('factura.descargar.xml', (user) => {
  return user.can([
    'factura.descargar.xml',
    'autofacturacion.descargar.xml'
  ]);
});
